export default __webpack_public_path__ + "static/section4-cc80cb894d76a8d537d326ba2d5f0cb6.webp";